$(".faq-special h3").on('click', function() {
    $(this).next('.wp-block-columns').slideToggle(); // Alterna a visibilidade do conteúdo
    $(this).toggleClass('active'); // Alterna a classe para girar a seta
});

$(".semestre").on('click', function() {
    // Alterna a classe 'active' no elemento seguinte com a classe 'matriz'
    $(this).next('.matriz').toggleClass('active');
    
    // Alterna a classe 'active' no elemento <h3> dentro do elemento clicado
    $(this).find('h3').toggleClass('active');
});

    // Detecta cliques em <p> que possuem <strong>
    $(".professores .wp-block-column p:has(strong)").on("click", function () {
        const $this = $(this);

        // Verifica se o elemento clicado já está ativo
        if ($this.hasClass("active")) {
            // Se ativo, remove a classe e oculta subsequentes
            $this.removeClass("active");
        } else {
            // Se não ativo, ativa o elemento clicado e desativa os outros
            $(".professores .wp-block-column p").removeClass("active");
            $this.addClass("active");
        }
    });

